import * as React from 'react';
import classnames from 'classnames';
import { BetInputContainer } from '../../../../../BetInput';
import { getLeadBetPositionText } from '../ServiceContainer/utils';
import { BetPositionTooltip } from '../../BetPositionTooltip';
import { ServicePrice } from '../../ServicePrice';
import topIcon from './assets/top.svg';
import { GenericService } from '../GenericService';
import { IServiceComponentProps } from '../ServiceContainer/types';
import { useTopService } from './hooks/useTopService';
import * as styles from './TopService.css';
import { SearchResultPosition } from '../../../../components';
import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../../../../../../../../selectors/layout';

export const TopService = ({ onClick, formattedPrice, isSelected, subtitle, description }: IServiceComponentProps) => {
  const isMobile = useSelector(selectIsMobileLayout);
  const { showPrice, showBetPosition, topBetServiceTitle, isTopServiceUnavailable, topAuctionBetPosition } =
    useTopService();

  return (
    <>
      {showBetPosition && !isMobile && (
        <BetPositionTooltip loading={false}>{getLeadBetPositionText(topAuctionBetPosition!)}</BetPositionTooltip>
      )}
      <GenericService
        className={classnames({ [styles.top]: !showPrice })}
        title={topBetServiceTitle}
        subtitle={subtitle}
        description={description}
        dataName="TopService"
        bgColor="gradient"
        onClick={onClick}
        checked={isSelected}
        unavailable={isTopServiceUnavailable}
        icon={<img src={topIcon} />}
      >
        {showPrice ? (
          <ServicePrice price={formattedPrice} />
        ) : (
          <div className={styles.input}>
            <BetInputContainer />
          </div>
        )}
      </GenericService>

      {showBetPosition && isMobile && (
        <SearchResultPosition
          place={topAuctionBetPosition}
          color={isSelected ? 'primary_100' : 'fill_secondary_active_30'}
        />
      )}
    </>
  );
};
